import { marked } from 'marked';
import hljs from 'highlight.js';

// Configure marked
marked.use({
  breaks: true,
  gfm: true,
});

// Custom renderer for code blocks with syntax highlighting
const renderer = new marked.Renderer();
const originalCode = renderer.code.bind(renderer);
renderer.code = function(code: string, language: string | undefined) {
  if (language && hljs.getLanguage(language)) {
    try {
      const highlighted = hljs.highlight(code, { language }).value;
      return `<pre><code class="hljs language-${language}">${highlighted}</code></pre>`;
    } catch (e) {
      console.error('Highlight error:', e);
    }
  }
  const autoHighlighted = hljs.highlightAuto(code).value;
  return `<pre><code class="hljs">${autoHighlighted}</code></pre>`;
};

marked.use({ renderer });

export function renderMarkdown(content: string): string {
  try {
    return marked(content) as string;
  } catch (error) {
    console.error('Markdown parsing error:', error);
    return content;
  }
}
